import React from "react";
import { Button } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Wrapper from "~/shared/ui/Wrapper";
import { ROLE_TYPES } from "~/constans/roles";
import { checkRole } from "~/hooks/checkRole";
import { useURLParamsSetter } from "~/hooks/useURLParamsSetter";
import { usePermissions } from "~/shared/context/PermissionContext";

import AdminLicenseManagementFilter from "./AdminLicenseManagementFilter";
import AdminLicenseManagementView from "./AdminLicenseManagementView";

const LicenseManagement = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const setParams = useURLParamsSetter();
  const role = checkRole();
  const isAdmin = role === ROLE_TYPES.ADMIN.name;
  const canSelectDealer = isAdmin || role === ROLE_TYPES.HOLDING.name;
  const { hasPermission } = usePermissions();
  const canCreateRequest = hasPermission(
    "employeeAccounting.license-requests.post",
  );

  const goBack = () => history.replace("/staff/licenses");

  const openRequestModal = () =>
    setParams({ openModal: "CreateRequest", currentId: undefined });

  return (
    <Wrapper.Content
      title={t("licenseManagement.title")}
      txtBtn={t("ui.back")}
      goBackHandler={goBack}
      controlComponent={
        canCreateRequest ? (
          <Button
            bold
            color="primary"
            fontSize="12"
            size="medium"
            onClick={openRequestModal}
            radius={5}
          >
            {t("licenseManagement.requestAdditionalLicenses")}
          </Button>
        ) : undefined
      }
      filterComponent={<AdminLicenseManagementFilter />}
    >
      <AdminLicenseManagementView
        isAdmin={isAdmin}
        canSelectDealer={canSelectDealer}
      />
    </Wrapper.Content>
  );
};

export default LicenseManagement;
